import { useQuery } from "@tanstack/react-query";
import { fetchUserDocument } from "@src/utility_functions/database_operations/users/readUser/fetchUserDocument";

export const useUserDocumentQuery = (userID, loggedInUserID, userIDReady) => {
  const queryResult = useQuery({
    queryKey: ["userDocument", userID, loggedInUserID],
    queryFn: fetchUserDocument,
    refetchOnWindowFocus: true,
    enabled: userIDReady,
    select: (data) => {
      return data ?? "userNotFound";
    },
  });
  return queryResult;
};
